<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper">
                <div class="modal-container">
                    <font-awesome-icon
                        title="Fermer"
                        icon="window-close"
                        class="dismiss-icon"
                        @click="$emit('modal:dismiss')"
                    />
                    <div class="modal-header"><slot name="header">default header</slot></div>
                    <div class="modal-body"><slot name="body">default body</slot></div>
                    <div class="modal-error"><slot name="error"></slot></div>
                    <div class="modal-footer">
                        <slot name="footer">
                            default footer
                            <button class="modal-default-button" @click="$emit('modal:dismiss')">
                                OK
                            </button>
                        </slot>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    props: {},
};
</script>

<style lang="scss">
.modal-mask {
    position: fixed;
    // position: relative;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    transition: opacity 0.3s ease;
    overflow-y: scroll;
    display: flex;
    align-items: safe center;
    justify-content: center;

    .modal-wrapper {
        // position: absolute;
        // top: 50%;
        // left: 50%;
        // transform: translate(-50%, -50%);

        .modal-container {
            width: 550px;
            padding: 10px 0;
            margin: 0 auto;
            background-color: #fff;
            border-radius: 25px;
            border-top: 5px solid #6c3e91;
            box-shadow: 0 0 7px 2px rgba(79, 79, 79, 0.5);
            transition: all 0.3s ease;
            font-family: Helvetica, Arial, sans-serif;

            .dismiss-icon {
                margin: 20px;
                height: 20px;
                width: 20px;
                color: #9ca5b0;
                cursor: pointer;
            }

            .modal-header h3 {
                color: #2a2a2a;
                font-size: 19px;
                font-weight: 600;
                line-height: 26px;
                text-align: center;
                white-space: pre;
            }

            .modal-body {
                margin: 20px 0;
                //text-align: center;
            }

            .modal-error {
                text-align: center;
                white-space: pre;
            }
        }
    }

    &.red-theme .modal-wrapper .modal-container {
        border-top: 5px solid #ea5b0c;
    }
    &.blue-theme .modal-wrapper .modal-container {
        border-top: 5px solid #6cd3fb;
    }
}

.modal-default-button {
    float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
    opacity: 0;
}

.modal-leave-active {
    opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
}
</style>
